export default {
  routes: {
    '.': {
      onEnter({ routeTo }) {
        routeTo('https://zapier.com/partner/embed/workflow', { exit: true });
      },
    },
  },
};
